import React from "react";

import { RouteConfig } from "@/routes/routes";
import { POST } from "@/shared/constants/routes";

import PostRoutes from "@/features/post/presentation/routes/PostRoutes";

export const routes: RouteConfig[] = [
  {
    path: POST,
    element: <PostRoutes />,
    isPrivate: true
  }
];
